module.exports = __webpack_public_path__ + "static/media/logo.e7b15dfe.png";